<template>
  <v-card>
    <v-system-bar color="warning"> Worklogs </v-system-bar>
    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        :to="{
          name: 'WorklogEdit',
          params:
            item.id == 0 ? { id: item.id, date: today() } : { id: item.id },
        }"
      >
        <v-list-item-content>
          <v-list-item-title>
            <DateValue :value="item.date" long />
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.date === today()">
            Heute
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-icon v-if="item.id == 0">mdi-file-plus</v-icon>
        <v-icon v-else>mdi-file-edit</v-icon>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions
      ><v-btn block text :to="{ name: 'Worklogs' }" :loading="loading"
        >Worklogs</v-btn
      ></v-card-actions
    >
  </v-card>
</template>
<script>
import { defineComponent } from "vue";

import DateValue from "common/components/DateValue.vue";
import { addDays, today } from "common/utils/date.js";

export default defineComponent({
  name: "WorklogButton",
  components: { DateValue },
  data() {
    return { items: [], loading: false };
  },
  watch: {},
  methods: {
    today,
    async getData() {
      this.loading = true;
      const end = today();
      const start = addDays(end, -7);
      this.items = (
        await this.apiList({
          resource: "worklog/worklog",
          query: "start=" + start + "&end=" + end,
        })
      )
        .filter((el) => el.author === this.$_profilePerson.code)
        .sort((a, b) => (a.date < b.date ? 1 : b.date < a.date ? -1 : 0));

      this.items.find((element) => element.date === today()) ||
        this.items.unshift({
          id: 0,
          date: today(),
        });

      this.loading = false;
    },
  },
  created() {
    this.getData();
  },
});
</script>
